import { useState } from 'react';
import PersonSelectorCombobox from '@/components/Combobox/PersonSelectorCombobox';
import Icon from '@/components/Icon/Icon';
import { HStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { TextVariant } from '@/components/Typography/Text.variant';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import PersonAvatar from '@/features/app-user/components/PersonAvatar';
import type { Person } from '@/features/app-user/types';
import type { TFunction } from '@/lib/i18n';
const PersonSelect = ({
  value,
  onValueChange,
  t
}: {
  value: Person | null;
  onValueChange: (person: Person | null) => void;
  t: TFunction<'translation', 'domain.appUser.component.ChangePersonDialog'>;
}) => {
  const [selectorOpen, setSelectorOpen] = useState(false);
  return <div className="relative">
      {value ? <HStack className="gap-3 justify-between items-center">
          <PersonAvatar person={{
        id: value.id,
        name: value.name,
        email: value.email,
        avatarUrl: value.avatarUrl
      }} />
          <Popover open={selectorOpen} onOpenChange={setSelectorOpen} modal={true}>
            <PopoverTrigger asChild>
              <Button variant="ghost" className="flex items-center gap-1 px-3 py-2 h-auto">
                <Icon iconName="PencilIcon" className="w-4 h-4" />
                <Text variant={TextVariant.label}>{t('Edit')}</Text>
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[400px] p-0" align="end" side="bottom" sideOffset={5}>
              <div className="max-h-[300px] overflow-y-auto">
                <PersonSelectorCombobox onSelect={person => {
              onValueChange(person);
              setSelectorOpen(false);
            }} onClose={() => setSelectorOpen(false)} />
              </div>
            </PopoverContent>
          </Popover>
        </HStack> : <Popover open={selectorOpen} onOpenChange={setSelectorOpen} modal={true}>
          <PopoverTrigger asChild>
            <Button variant="outline" className="w-[200px] justify-between">
              <Text variant={TextVariant.labelReg}>
                {t('selectInputPlaceholder')}
              </Text>
              <Icon iconName="ChevronDownIcon" className="w-4 h-4 text-muted-foreground" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-[400px] p-0" align="start" side="bottom" sideOffset={5}>
            <div className="max-h-[300px] overflow-y-auto">
              <PersonSelectorCombobox onSelect={person => {
            onValueChange(person);
            setSelectorOpen(false);
          }} onClose={() => setSelectorOpen(false)} />
            </div>
          </PopoverContent>
        </Popover>}
    </div>;
};
export default PersonSelect;